import React, { useState, useRef } from 'react';
import './Careers.css';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../utils/routes';
const contactBanner = process.env.PUBLIC_URL + '/images/career/careerbg.jpg';

const positions = [
  'SAP Consultant',
  'Data Engineer',
  'AI Specialist',
  'Integration Architect',
  'Project & Delivery Professional',
];

const experienceLevels = [
  '0 – 1 Year (Fresher)',
  '1 – 3 Years',
  '3 – 5 Years',
  '5 – 10 Years',
  '10+ Years',
];

const whyJoin = [
  {
    icon: 'bi-briefcase-fill',
    title: 'Work on meaningful enterprise transformation initiatives',
  },
  {
    icon: 'bi-cpu-fill',
    title: 'Build exposure across SAP, data, AI, and emerging technology',
  },
  {
    icon: 'bi-people-fill',
    title: 'Learn in a collaborative and growth-oriented environment',
  },
  {
    icon: 'bi-graph-up-arrow',
    title: 'Contribute to a company shaping its next stage of growth',
  },
  {
    icon: 'bi-globe2',
    title: 'Gain experience across industries and client needs',
  },
];

const initialForm = {
  name: '',
  email: '',
  phone_number: '',
  applied_for: '',
  address: '',
  city_town: '',
  skills: '',
  experience: '',
  resume: '',
};

export default function Careers() {
  const navigate = useNavigate();
  const handleNavigateHome = () => {
    navigate(ROUTES.HOME);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const [formData, setFormData] = useState(initialForm);
  const [submitted, setSubmitted] = useState(false);
  const [dragOver, setDragOver] = useState(false);
  const fileInputRef = useRef(null);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFile = (file) => {
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) {
      alert('File size must be under 5 MB.');
      return;
    }
    setFormData({ ...formData, resume: file });
  };

  const handleFileInput = (e) => handleFile(e.target.files[0]);

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    handleFile(e.dataTransfer.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const data = new FormData();

      data.append("name", formData.name);
      data.append("email", formData.email);
      data.append("phone_number", formData.phone_number);
      data.append("applied_for", formData.applied_for);
      data.append("address", formData.address);
      data.append("city_town", formData.city_town);
      data.append("skills", formData.skills);
      data.append("experience", formData.experience);

      if (formData.resume) {
        data.append("resume", formData.resume);
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/submit-career`,
        {
          method: "POST",
          headers: {
            "api-username": process.env.REACT_APP_API_URL_USERNAME,
            "api-password": process.env.REACT_APP_API_URL_PASSWORD,
            "Accept": "application/json"
          },
          body: data
        }
      );

      const result = await response.json();

      console.log(result);

      if (result.status === true) {
        setSubmitted(true);
        setFormData(initialForm);
      } else {
        setErrors(result.errors || {});
      }

    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {/* ── Banner ── */}
      <section className="careers-banner inner-page-banner" style={{ backgroundImage: `url(${contactBanner})` }}>
        <div className="careers-banner-overlay inner-page-banner-overlay" />
        <div className="container careers-banner-inner inner-page-banner-inner">
          <h1 className="inner-page-banner-title">Careers</h1>
        </div>
      </section>

      <div className="inner-page-breadcrumb-wrap">
        <div className="container">
          <nav className="inner-page-breadcrumb">
            <button type="button" className="inner-page-home" onClick={handleNavigateHome}>Home</button>
            <span className="inner-page-sep"><i className="bi bi-chevron-right" /></span>
            <span className="inner-page-current">Careers</span>
          </nav>
        </div>
      </div>

      {/* ── Intro ── */}
      <section className="careers-intro-section">
        <div className="container">
          <div className="careers-intro" data-aos="fade-up">
            <h2 className="careers-heading">Build the future with MS Technologies</h2>
            <p className="careers-subtext">
              Join a team focused on enterprise transformation, modern technology, and practical business outcomes. We are building across SAP, data platforms, AI, and digital innovation.
            </p>
          </div>
        </div>
      </section>

      {/* ── Two-Column: Why Join Us + Form ── */}
      <section className="careers-main-section">
        <div className="container">
          <div className="row g-5 align-items-start">

            {/* ── Left: Why Join Us ── */}
            <div className="col-lg-5" data-aos="fade-right">
              <div className="why-join-wrap">
                {/* <span className="careers-tag">Why Us</span> */}
                <h3 className="why-join-title">Why join us</h3>
                <p className="why-join-sub">
                  At MS Technologies you will work on initiatives that genuinely move the needle for
                  enterprise clients across multiple industries.
                </p>
                <div className="why-join-list">
                  {whyJoin.map((item) => (
                    <div key={item.title} className="wj-item" data-aos="fade-up">
                      <div className="wj-icon">
                        <i className={`bi ${item.icon}`} />
                      </div>
                      <div className="wj-body">
                        <h5 className="wj-title">{item.title}</h5>
                        {/* <p className="wj-text">{item.text}</p> */}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* ── Right: Application Form ── */}
            <div className="col-lg-7" data-aos="fade-left">
              <div className="careers-form-card">
                {submitted ? (
                  <div className="careers-success">
                    <div className="cs-icon"><i className="bi bi-check-circle-fill" /></div>
                    <h3>Application Received!</h3>
                    <p>
                      Thank you for your interest in MS Technologies. Our team will review your
                      application and be in touch shortly.
                    </p>
                    <button
                      className="btn-careers-submit"
                      onClick={() => { setSubmitted(false); setFormData(initialForm); }}
                    >
                      Submit Another Application
                    </button>
                  </div>
                ) : (
                  <>
                    <div className="cf-form-header">
                      <h3 className="cf-form-title">Join Our Team</h3>
                      <p className="cf-form-sub">Apply now for exciting job opportunities and unlock endless possibilities.</p>
                    </div>

                    <form onSubmit={handleSubmit} encType="multipart/form-data" >
                      <div className="row g-3">

                        {/* Full Name + Email */}
                        <div className="col-sm-6">
                          <label className="cf-label">Full Name <span>*</span></label>
                          <input
                            type="text"
                            name="name"
                            className="cf-input"
                            placeholder="Full Name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                          />
                          {errors.name && (
                            <span className="text-danger">
                              {errors.name[0]}
                            </span>
                          )}
                        </div>
                        <div className="col-sm-6">
                          <label className="cf-label">Email Address <span>*</span></label>
                          <input
                            type="email"
                            name="email"
                            className="cf-input"
                            placeholder="Email Address"
                            value={formData.email}
                            onChange={handleChange}
                            required
                          />
                          {errors.email && (
                            <span className="text-danger">
                              {errors.email[0]}
                            </span>
                          )}
                        </div>

                        {/* Phone + Position */}
                        <div className="col-sm-6">
                          <label className="cf-label">Phone Number <span>*</span></label>
                          <input
                            type="tel"
                            name="phone_number"
                            className="cf-input"
                            placeholder="+1 98765 43210"
                            value={formData.phone_number}
                            onChange={handleChange}
                            required
                          />
                          {errors.phone_number && (
                            <span className="text-danger">
                              {errors.phone_number[0]}
                            </span>
                          )}
                        </div>
                        <div className="col-sm-6">
                          <label className="cf-label">Position Applied For <span>*</span></label>
                          <div className="cf-select-wrap">
                            <select
                              name="applied_for"
                              className="cf-input cf-select"
                              value={formData.applied_for}
                              onChange={handleChange}
                              required
                            >
                              <option value="" disabled>Select Position</option>
                              {positions.map((p) => (
                                <option key={p} value={p}>{p}</option>
                              ))}
                            </select>
                            <i className="bi bi-chevron-down cf-select-icon" />
                          </div>
                          {errors.applied_for && (
                            <span className="text-danger">
                              {errors.applied_for[0]}
                            </span>
                          )}
                        </div>

                        {/* Address + City */}
                        <div className="col-sm-6">
                          <label className="cf-label">Address</label>
                          <input
                            type="text"
                            name="address"
                            className="cf-input"
                            placeholder="Enter Address"
                            value={formData.address}
                            onChange={handleChange}
                          />
                          {errors.address && (
                            <span className="text-danger">
                              {errors.address[0]}
                            </span>
                          )}
                        </div>
                        <div className="col-sm-6">
                          <label className="cf-label">Current City / Town</label>
                          <input
                            type="text"
                            name="city_town"
                            className="cf-input"
                            placeholder="City / Town"
                            value={formData.city_town}
                            onChange={handleChange}
                          />
                          {errors.city_town && (
                            <span className="text-danger">
                              {errors.city_town[0]}
                            </span>
                          )}
                        </div>

                        {/* Skills + Experience */}
                        <div className="col-sm-6">
                          <label className="cf-label">Skill Set <span>*</span></label>
                          <input
                            type="text"
                            name="skills"
                            className="cf-input"
                            placeholder="e.g. SAP FICO, Python, SQL"
                            value={formData.skills}
                            onChange={handleChange}
                            required
                          />
                          {errors.skills && (
                            <span className="text-danger">
                              {errors.skills[0]}
                            </span>
                          )}
                        </div>
                        <div className="col-sm-6">
                          <label className="cf-label">Experience Level <span>*</span></label>
                          <div className="cf-select-wrap">
                            <select
                              name="experience"
                              className="cf-input cf-select"
                              value={formData.experience}
                              onChange={handleChange}
                              required
                            >
                              <option value="" disabled>Select Experience</option>
                              {experienceLevels.map((lvl) => (
                                <option key={lvl} value={lvl}>{lvl}</option>
                              ))}
                            </select>
                            <i className="bi bi-chevron-down cf-select-icon" />
                          </div>
                          {errors.experience && (
                            <span className="text-danger">
                              {errors.experience[0]}
                            </span>
                          )}
                        </div>

                        {/* Resume Upload */}
                        <div className="col-12">
                          <label className="cf-label">
                            Upload Resume <span>*</span>
                          </label>
                          <div
                            className={`cf-upload-zone${dragOver ? ' drag-over' : ''}`}
                            onClick={() => fileInputRef.current.click()}
                            onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
                            onDragLeave={() => setDragOver(false)}
                            onDrop={handleDrop}
                          >
                            <input
                              ref={fileInputRef}
                              type="file"
                              name="resume"
                              accept=".pdf"
                              style={{ display: 'none' }}
                              onChange={handleFileInput}
                              required
                            />
                            <i className="bi bi-cloud-arrow-up cf-upload-icon" />
                            {formData.resume ? (
                              <p className="cf-upload-text">
                                <span className="cf-upload-link">{formData.resume.name}</span>
                              </p>
                            ) : (
                              <p className="cf-upload-text">
                                <span className="cf-upload-link">Click to upload</span> or drag and drop
                              </p>
                            )}
                            <p className="cf-upload-hint">Max size: 5MB</p>
                          </div>
                          {errors.resume && (
                            <span className="text-danger">
                              {errors.resume[0]}
                            </span>
                          )}
                        </div>


                        <div className="col-12">
                          <button type="submit" className="btn-careers-submit">
                            Submit Application <i className="bi bi-send-fill" />
                          </button>
                        </div>

                      </div>
                    </form>
                  </>
                )}
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}
